import { createTheme } from '@mui/material/styles';
import { Theme } from '@mui/styles';

import LovesDocumentAssemblyWebImport from "~capture/components/document-assembly-web-import";
LovesDocumentAssemblyWebImport.register();

import PresentConfirmOnClose from '~common/components/present-cancel-confirmation-on-close'
PresentConfirmOnClose.register()

import CheckRequestSuccess from '~common/components/check-request-submit-confirm'
CheckRequestSuccess.register()

import HudeDashboardCardRenderer from '~invoice-processing/components/hude-dashboard-card-renderer';
HudeDashboardCardRenderer.register()

// export const primaryColor = "#763e0b"
// export const raisedButtonPrimary =  "#763e0b"
export const primaryColor = "#763e0b"
export const raisedButtonPrimary =  "#FF0000"
export const secondaryColor = '#0B6623'
export const raisedButtonContained = "#bdbdbd" // grey
export const raisedButtonContainedDefault = "#bdbdbd"

import { grey } from "@mui/material/colors";

export const logoFileName ="/static/assets/loves.png"

declare module "@mui/material/Button" {
    interface ButtonPropsColorOverrides {
        default: true;
    }
  }
  
  declare module '@mui/styles' {
    interface DefaultTheme extends Theme {}
  }
  
  declare module "@mui/material" {
    interface Color {
        main: string;
        dark: string;
    }
  }

  export const formBasedTaskContainerFixedToolbarStyle = {
    position: "fixed",
    top: 170,
    height: "100%",
    width: "auto",
    paddingRight: 10,
    overflow: "scroll",
  };
  

export const theme = createTheme({
	palette: {
        mode: "light",
        primary: {
			main: primaryColor,
        },
        secondary: {
            main:secondaryColor,
        },
		default: {
			main: grey[300],
			dark: grey[400]
		}
    },
	typography: {
		fontFamily: [
			'Mulish',
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif',
		].join(','),
	},
	components: {
		MuiTextField: {
			defaultProps: {
				variant: 'standard'
			}
		},
		MuiInputLabel: {
			defaultProps: {
				shrink: true
			}
		},
		MuiFormControl: {
			defaultProps: {
			  	variant: 'standard'
			}
		},
		MuiFormSelect: {
			defaultProps: {
			  	variant: 'standard'
			}
		},
		MuiAppBar: {
			defaultProps: {
			style: {
					background: 'linear-gradient(0deg, #e5e500 0%, #ffeb00 100%)',
				}
			},
			// styleOverrides: {
			// 	root: {
			// 		background: 'linear-gradient(0deg, #e5e500 0%, #ffeb00 100%)',
			// 	}
			// }
		},
		MuiButton: {
			styleOverrides: {
				root: {
					'&.MuiButton-containedPrimary': {
						backgroundColor: raisedButtonPrimary,
						color: '#ffffff',
						'&:hover': {
							backgroundColor: raisedButtonPrimary,
							opacity: 0.9
						}
					},
					'&.MuiButton-contained': {
						backgroundColor: raisedButtonPrimary,
						color: '#ffffff',
						'&:hover': {
							backgroundColor: raisedButtonPrimary,
							opacity: 0.9
						}
					},
					'&.MuiButton-containedSecondary': {
						backgroundColor: raisedButtonPrimary, // Changed this to primary color as per LOVES 4282
						color: '#ffffff',
						'&:hover': {
							backgroundColor: raisedButtonContained,
							opacity: 0.9
						}

					},
					'&.Mui-disabled': {
						color: '#ffffff',
						backgroundColor: raisedButtonContained,
						opacity: 1, // if parent opacity washes out the label
						WebkitTextFillColor: '#ffffff', // helps with some WebKit disabled inputs; rarely needed on buttons
					  },
					// '&.MuiButton-containedSecondary': {
					// 	backgroundColor: raisedButtonContained,
					// 	color: '#ffffff',
					// 	'&:hover': {
					// 		backgroundColor: raisedButtonContained,
					// 		opacity: 0.9
					// 	}
					// },
					'&.MuiButton-outlined': {
						borderColor: "#ff8000",
						backgroundColor: "#fff",
						color: "black"
					}
				}
			}
		},
		MuiIcon: {
			styleOverrides: {
				root: {
					color: raisedButtonPrimary
				}
			}
		},
		MuiBadge: {
			defaultProps: {
				// colorPrimary: {
				// 	backgroundColor: raisedButtonPrimary,
				// },
			}
		},
		MuiFormLabel: {
			defaultProps: {
			  	sx: {'& .MuiFormLabel-asterisk': {'color': 'red'}, color: primaryColor}
			}
		},
		MuiTypography: {
			defaultProps: {
				h5: {
					fontSize: "1.75rem",
					fontWeight: 500,
					lineHeight: "1.20588em",
					marginBottom: 15
				},
				subtitle1: {
					color: primaryColor
				}
		  	}
		},
		MuiListSubheader: {
			defaultProps: {
				sticky: {
						backgroundColor: "#fff",
				},
			}
		},
		MuiPaper: {
			defaultProps: {
				stylex: {
					padding: 30,
				}
			},
		
		},
	},
	//props: {
		// MuiTextField: {
		//   variant: 'standard'
		// },
		// MuiFormControl: {
		//   variant: 'standard'
		// },
		// MuiFormSelect: {
		//   variant: 'standard'
		// },
	//},
    //overrides: {
		// MuiAppBar: { // Name of the component ⚛️ / style sheet
		//   root: { // Name of the rule
		// 	background: 'linear-gradient(0deg, #e5e500 0%, #ffeb00 100%)',
        //   },
		// },
		// MuiButton: {
		// 	outlined: {
		// 		borderColor: "#ff8000",
		// 		backgroundColor: "#fff",
		// 		color: "black"
		// 	},
		// 	outlinedPrimary: {
		// 		borderColor: "#ff8000",
		// 		backgroundColor: "#fff",
		// 		color: "black"
		// 	},
		// 	outlinedSecondary: {
		// 		borderColor: "#ff8000",
		// 		backgroundColor: "#fff",
		// 		color: "black"
		// 	},
		// 	containedPrimary: {
		// 		backgroundColor: raisedButtonPrimary,
		// 		color: "#fff"
		// 	},
		// 	contained: {
		// 		backgroundColor: raisedButtonContainedDefault,
		// 		color: '#1f1f1f'
		// 	},
		// 	containedSecondary: {
		// 		backgroundColor: raisedButtonContained,
		// 		color: "#fff"
		// 	}
		// },
		// MuiBadge: {
		// 	colorPrimary: {
		// 		backgroundColor: raisedButtonPrimary
		// 	}
		// },
        // MuiFormLabel:{
        //     asterisk: {
        //         color: 'red',
        //         fontWeight:600
        //     },
        //     root: {
        //         color: primaryColor 
        //     }
        // },
        // MuiTypography: {
        //     h5: {
        //         fontSize: "1.75rem",
        //         fontWeight: 500,
        //         lineHeight: "1.20588em",
        //         marginBottom: 15
        //     },
        //     subtitle1: {
        //             color: primaryColor
        //     }
		// },
		// MuiListSubheader:{
		// 	sticky: {
		// 		backgroundColor: '#fff'
		// 	}
		// }
    //}
  })

  export const styleRules = {
	root: {
		textAlign: 'unset',
		// paddingTop: 75,
		paddingLeft: 15,
        paddingRight: 15,
        //background: "black url(https://static.boydgaming.net/boydgaming/assets/shell/background.jpg) top no-repeat;",

	},
	toolbar: {
		'@media only print': {display: 'none'}	
	},
	appContents: {
		//marginTop: 60,
	},
	flex: {
		flex: 1
	},
	appTitle: {
		flex: 1,
		color: '#bdbdbd',
		marginTop: 5,
		fontFamily: "Arial,san-serif,Helvetica,Trebuchet MS"
	},
	drawerList: {
		width: 250
	},
	menuButton: {
		color: "#ff0000",
		marginLeft: -12,
		marginRight: 20,
	},
	welcomeText: {
		color: '#6C6801',
		marginTop: 5,
		marginRight: 5,
		fontFamily: "Arial,san-serif,Helvetica,Trebuchet MS"
	},
	logo: {
        marginTop: 0,
		height: 40,
		width: 'auto'
	},
	bottomPadding: {
		height: 60
	},
	// chip: {
	// 	margin: theme.spacing.unit
	// },
	homeIcon: {
		marginRight: 10
	},
	home: {
		color: "#ff0000",
	}
}
